import type { GyymApiClient } from '@gyym/sdk'
import React from 'react'

export const GyymApiContext = React.createContext<GyymApiClient>(
  {} as GyymApiClient,
)

export interface GyymClientProviderProps {
  client: GyymApiClient
  children: React.ReactNode
}

export const GyymClientProvider = ({
  client,
  children,
}: GyymClientProviderProps) => (
  <GyymApiContext.Provider value={client}>{children}</GyymApiContext.Provider>
)
